export const MOVFIT_DASHBOARD_AUTOMACOES_WEBHOOK =
  (typeof process !== 'undefined' &&
    process.env &&
    (process.env.REACT_APP_MOVFIT_DASHBOARD_AUTOMACOES_WEBHOOK ||
      process.env.REACT_APP_MOVFIT_COBRANCA_AUTOMATICA_WEBHOOK)) ||
  'https://n8n2.mov.pro.br/webhook/dashboard_automacoes';

export function formatMesReferencia(ym) {
  if (!ym || typeof ym !== 'string') return '';
  const parts = ym.split('-');
  const y = Number(parts[0]);
  const mo = Number(parts[1]);
  if (!Number.isFinite(y) || !Number.isFinite(mo) || mo < 1 || mo > 12) return ym;
  const d = new Date(y, mo - 1, 1);
  return d.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' });
}

function unwrapN8nPayload(raw) {
  let root = raw;
  if (Array.isArray(root) && root.length > 0) {
    root = root[0];
  }
  if (root?.data != null && typeof root.data === 'object' && !Array.isArray(root.data)) {
    root = root.data;
  }
  return root;
}

export function mesReferenciaAtualYm() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
}

export function formatValorMetricaDisplay(val) {
  if (val === undefined || val === null || val === '') return '0';
  const n = Number(val);
  if (Number.isFinite(n)) return n.toLocaleString('pt-BR');
  return String(val);
}

/**
 * Webhook dashboard_automacoes: { cobranca, aniversariantes }.
 * Compatível com wrapper array/`data` do n8n. Aceita também formato legado `metricas`.
 */
export function parseDashboardAutomacoesMovFit(raw) {
  const root = unwrapN8nPayload(raw);

  const legacy = root?.metricas;
  if (legacy && typeof legacy === 'object' && !root?.cobranca) {
    const totalGeral = Number(legacy.total_geral);
    const totalMes = Number(legacy.total_mes_atual);
    const unidadesBruto = Array.isArray(legacy.unidades) ? legacy.unidades : [];
    const unidades = unidadesBruto
      .filter((u) => u && typeof u === 'object')
      .map((u) => ({
        unidade: String(u.unidade ?? '').trim() || 'Unidade',
        total_unidade: Number.isFinite(Number(u.total_unidade)) ? Number(u.total_unidade) : 0,
        total_mes_atual_unidade: Number.isFinite(Number(u.total_mes_atual_unidade))
          ? Number(u.total_mes_atual_unidade)
          : 0
      }));
    const mesAtual =
      typeof legacy.mes_atual === 'string' && legacy.mes_atual ? legacy.mes_atual : mesReferenciaAtualYm();
    return {
      cobranca: {
        total_geral: Number.isFinite(totalGeral) ? totalGeral : 0,
        mes_atual: mesAtual,
        total_mes_atual: Number.isFinite(totalMes) ? totalMes : 0,
        unidades
      },
      aniversariantes: { total: 0, mensal: 0 }
    };
  }

  const c = root?.cobranca;
  if (!c || typeof c !== 'object') return null;

  const totalGeral = Number(c.total_envios);
  const totalMes = Number(c.total_envio_mensal);
  const unidadesBruto = Array.isArray(c.por_unidades) ? c.por_unidades : [];

  const unidades = unidadesBruto
    .filter((u) => u && typeof u === 'object')
    .map((u) => ({
      unidade: String(u.unidade ?? '').trim() || 'Unidade',
      total_unidade: Number.isFinite(Number(u.total_unidade)) ? Number(u.total_unidade) : 0,
      total_mes_atual_unidade: Number.isFinite(Number(u.total_mes_atual_unidade))
        ? Number(u.total_mes_atual_unidade)
        : 0
    }));

  let mesAtual = '';
  if (typeof c.mes_atual === 'string' && c.mes_atual) mesAtual = c.mes_atual;
  else if (typeof c.mes_referencia === 'string' && c.mes_referencia) mesAtual = c.mes_referencia;
  else mesAtual = mesReferenciaAtualYm();

  const a = root?.aniversariantes;
  const mensalBruto =
    a && typeof a === 'object' ? a.tota_mensal ?? a.total_mensal ?? a.total_mes_atual : undefined;
  const totalBruto = a && typeof a === 'object' ? a.total : undefined;

  return {
    cobranca: {
      total_geral: Number.isFinite(totalGeral) ? totalGeral : 0,
      mes_atual: mesAtual,
      total_mes_atual: Number.isFinite(totalMes) ? totalMes : 0,
      unidades
    },
    aniversariantes: {
      total: totalBruto !== undefined && totalBruto !== null && totalBruto !== '' ? totalBruto : 0,
      mensal:
        mensalBruto !== undefined && mensalBruto !== null && mensalBruto !== '' ? mensalBruto : 0
    }
  };
}
